<h2 mat-dialog-title>Invalid Payment Refund</h2>
<mat-dialog-content class="mat-typography">
  <h4>This refund cannot be processed. This refund cannot be matched up with a previous payment.  Some hints to help find the issue:</h4>
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>

